import Swal from 'sweetalert2/dist/sweetalert2.all.js';

export const Toaster = {
  default: Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  }),
};

export const Toast = {
  success: (message) =>
    Toaster.default.fire({
      icon: 'success',
      title: message,
    }),
  warning: (message) =>
    Toaster.default.fire({
      icon: 'warning',
      title: message,
    }),
  error: (message) =>
    Toaster.default.fire({
      icon: 'error',
      title: message,
    }),
  info: (message) =>
    Toaster.default.fire({
      icon: 'info',
      title: message,
    }),
};

export default Toast;
